// Glood rows ("You may also like", recently viewed) add to cart with their own request, so the theme never hears about it:
// the cart number stayed stale and the "added to cart" popup never opened (Hamza 2026-10-12).
// After a Glood tap, watch for the /cart/add request, then refresh the bubble + open the popup the same way our own Add to cart does.
(function () {
  if (window.__bjoCartSync) return; window.__bjoCartSync = true;
  var lastTap = 0;
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.ga-product_addtocart, [id*="__glo_"]')) lastTap = Date.now();
  }, true);
  var ours = function (url) { return Date.now() - lastTap < 5000 && /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url || '')); };
  var sync = function (added) {
    var item = added && (added.items ? added.items[0] : added);
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var ids = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
    fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (cart && item && item.key) { cart.renderContents(Object.assign({}, item, { sections: sections })); return; }
        var b = document.getElementById('cart-icon-bubble'), html = sections['cart-icon-bubble'];
        if (b && html) b.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section').innerHTML;
      })
      .catch(function () {});
  };
  var oFetch = window.fetch;
  window.fetch = function (input) {
    var p = oFetch.apply(this, arguments);
    if (ours(typeof input === 'string' ? input : input && input.url)) {
      lastTap = 0;
      p.then(function (res) { if (res.ok) res.clone().json().then(sync, function () { sync(null); }); }, function () {});
    }
    return p;
  };
  var oOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (ours(url)) {
      lastTap = 0;
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        var data = null; try { data = JSON.parse(this.responseText); } catch (e) {}
        sync(data);
      });
    }
    return oOpen.apply(this, arguments);
  };

  // ---- empty cart "Put it back" + same-day pick "+" (sections/main-cart-items.liquid .bjo-empty; the bin stores the removed item)
  var KEY = 'bjoLastRemoved';
  window.bjoRemember = function (row) {
    try {
      if (!row || row.classList.contains('bjo-wrap-row') || !row.dataset.bjoVariant) return;
      sessionStorage.setItem(KEY, JSON.stringify({ v: row.dataset.bjoVariant, q: +row.dataset.bjoQty || 1, t: row.dataset.bjoTitle, i: row.dataset.bjoImg, at: Date.now() }));
    } catch (e) {}
  };
  var fillBack = function () {
    var box = document.querySelector('.bjo-empty__back');
    if (!box) return;
    var d = null; try { d = JSON.parse(sessionStorage.getItem(KEY)); } catch (e) {}
    if (!d || Date.now() - d.at > 30 * 60 * 1000) { box.hidden = true; return; }
    box.querySelector('img').src = d.i || '';
    box.querySelector('.bjo-empty__bt').textContent = d.t || '';
    box.hidden = false;
  };
  var add = function (id, q, btn) {
    if (btn) btn.disabled = true;
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: q || 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; location.reload(); })
      .catch(function () { if (btn) btn.disabled = false; });
  };
  document.addEventListener('click', function (e) {
    var put = e.target.closest && e.target.closest('.bjo-empty__put');
    if (put) { var d = null; try { d = JSON.parse(sessionStorage.getItem(KEY)); } catch (x) {} if (d) { try { sessionStorage.removeItem(KEY); } catch (x) {} add(d.v, d.q, put); } return; }
    var pk = e.target.closest && e.target.closest('.bjo-pick__add');
    if (pk) add(pk.dataset.variant, 1, pk);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillBack); else fillBack();
  window.bjoFillBack = fillBack;
})();
